class CartDropdown extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-dropdown-bubble-product');
	this.modal = document.getElementById('cart-modal');
    this.content = this.querySelector('.cart__dropdown-content');
    this.header = document.querySelector('sticky-header');
    this.shipping = document.getElementById('cart-dropdown-shipping');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.actionRemove();
    this.actionUpdateQuantity();
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }
  
  actionRemove() {
  	this.querySelectorAll('[data-cart-dropdown-remove]').forEach((remove) =>
      remove.addEventListener('click', this.remove.bind(this))
    );
  }

  actionUpdateQuantity() {
  	this.querySelectorAll('[data-cart-dropdown-quantity]').forEach((quantity) =>
      quantity.addEventListener('change', this.quantity.bind(this))
    );
  }
  
  remove(evt) {
    evt.preventDefault();
    
    const target = evt.target;
    this.shipping.classList.add('is-loading');
    this.iconRemove = target.closest('[data-cart-dropdown-remove]');
    this.itemProduct = target.closest('.cart__dropdown-item');
    this.itemProduct.classList.add('is-remove');
    const line = parseInt(this.iconRemove.dataset.cartDropdownRemove);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const formData = {
      'line': line,
      'quantity': 0,
    };
    
    config.body = JSON.stringify({
      ...formData,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    this.updateQuantity(config);
  }

  quantity(evt) {
    evt.preventDefault();
    
    const target = evt.target;
    this.shipping.classList.add('is-loading');
    this.itemQuantity = target.closest('[data-cart-dropdown-quantity]');
    this.itemProduct = target.closest('.cart__dropdown-item');
    this.itemProduct.classList.add('is-remove');
    const line = parseInt(this.itemQuantity.dataset.cartDropdownQuantity);
    const qty = parseInt(this.itemQuantity.value);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const formData = {
      'line': line,
      'quantity': qty,
    };
    
    config.body = JSON.stringify({
      ...formData,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    this.updateQuantity(config);
  }
  
  renderError(error) {
  	this.modal.classList.add('is-error');
    this.modal.querySelector('.cart-modal__title-error-message').innerHTML = error;
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.modal.classList.remove('is-error');
	this.modal.querySelector('.cart-modal__title-error-message').innerHTML = '';
    this.getSectionsToRender().forEach((section => {
      document.querySelectorAll(section.content).forEach((content) => {
        if (section.content == '[data-cart-modal-product]') {
          content.innerHTML = '';
          parsedState.items.forEach((item) => {
            $(this.getSectionInnerHTML(parsedState.sections[section.id], `#cart-modal-data-product-${item.id}`)).appendTo($(content));
            find(`#cart-modal-product__qty-${item.id}`, content).innerHTML = parsedState.quantityItem[item.id];
          });
        } else {
          const fragment = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (fragment !== null) content.innerHTML = fragment;
        }
      });
    }));

    this.updateHeaderCartCount(parsedState);
    this.applyCartViewLineCount(parsedState);

    this.header?.reveal();
    this.content.classList.remove('is-empty');
    this.open();
    this.actionRemove();
    this.actionUpdateQuantity();
  }
    
  renderUpdate(parsedState) {
    this.getSectionsToRender().forEach((section => {
      document.querySelectorAll(section.content).forEach((content) => {
        if (section.content != '[data-cart-modal-product]' && section.content != '[data-cart-modal-count]') {
          const fragment = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (fragment !== null) content.innerHTML = fragment;
        }
        if (section.content === '[data-cart-modal-count]') {
          const fragment = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (fragment !== null) content.innerHTML = fragment;
        }
      });
    }));
    this.updateHeaderCartCount(parsedState);
    this.applyCartViewLineCount(parsedState);

    this.actionRemove();
    this.actionUpdateQuantity();
    if (parsedState.item_count == 0) {
  	  this.content.classList.add('is-empty');
    }
  }

  /** Nombre de lignes panier depuis les sections Liquid (fiable après /cart/add). */
  resolveCartLineCount(parsedState) {
    const sections = parsedState?.sections;
    if (!sections) return null;

    const iconHtml = sections['cart-icon-bubble'];
    if (iconHtml) {
      const source = new DOMParser().parseFromString(iconHtml, 'text/html');
      const sourceCount = source.querySelector('.cart-count-bubble span[aria-hidden="true"]')?.textContent?.trim();
      if (sourceCount !== undefined && sourceCount !== null && sourceCount !== '') {
        const parsedCount = parseInt(sourceCount, 10);
        if (!Number.isNaN(parsedCount)) return parsedCount;
      }
    }

    const modalHtml = sections['cart-modal-data'];
    if (modalHtml) {
      const doc = new DOMParser().parseFromString(modalHtml, 'text/html');
      const viewCart = doc.querySelector('#cart-modal-data-view-cart')?.textContent;
      const parenMatch = viewCart?.match(/\(\s*(\d+)\s*\)/);
      if (parenMatch) {
        const parsedCount = parseInt(parenMatch[1], 10);
        if (!Number.isNaN(parsedCount)) return parsedCount;
      }
      const countBlock = doc.querySelector('#cart-modal-data-count')?.textContent;
      const numMatch = countBlock?.match(/(\d+)/);
      if (numMatch) {
        const parsedCount = parseInt(numMatch[1], 10);
        if (!Number.isNaN(parsedCount)) return parsedCount;
      }
    }

    if (Array.isArray(parsedState?.items) && parsedState.items.length > 0) {
      return parsedState.items.length;
    }

    if (typeof parsedState?.item_count === 'number') {
      return parsedState.item_count;
    }

    return null;
  }

  /** Met à jour les libellés « Afficher mon panier (N) ». */
  applyCartViewLineCount(parsedState) {
    const lineCount = this.resolveCartLineCount(parsedState);
    if (lineCount === null) return;
    document.querySelectorAll('[data-cart-view-line-count]').forEach((el) => {
      const t = el.textContent.replace(/\(\s*\d+\s*\)/, `(${lineCount})`);
      if (t !== el.textContent) el.textContent = t;
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-dropdown-bubble-product',
        content: '[data-cart-dropdown-bubble-product]'
      },
      {
        id: 'cart-dropdown-shipping',
        content: '[data-cart-dropdown-shipping]'
      },
      {
        id: 'cart-dropdown-bottom',
        content: '[data-cart-dropdown-bottom]',
        selector: '#cart-dropdown-bottom-fragment'
      },
      {
        id: 'cart-modal-data',
        content: '[data-cart-modal-total]',
        selector: '#cart-modal-data-total',
      },
      {
        id: 'cart-modal-data',
        content: '[data-cart-modal-count]',
        selector: '#cart-modal-data-count',
      },
      {
        id: 'cart-modal-data',
        content: '[data-cart-modal-view-cart]',
        selector: '#cart-modal-data-view-cart',
      },
      {
        id: 'cart-modal-data',
        content: '[data-cart-modal-product]'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : null;
  }

  updateHeaderCartCount(parsedState) {
    const lineCount = this.resolveCartLineCount(parsedState);
    if (lineCount === null) return;

    document.querySelectorAll('[data-cart-icon-bubble] .cart-count-bubble').forEach((bubble) => {
      const numberEl = bubble.querySelector('span[aria-hidden="true"]');
      const srEl = bubble.querySelector('.visually-hidden');

      if (numberEl) {
        if (lineCount < 100) {
          numberEl.textContent = String(lineCount);
          numberEl.style.display = '';
        } else {
          numberEl.textContent = '';
          numberEl.style.display = 'none';
        }
      }

      if (srEl) {
        const current = srEl.textContent || '';
        srEl.textContent = /\d+/.test(current) ? current.replace(/\d+/, String(lineCount)) : current;
      }
    });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
        
  updateQuantity(config) {
    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description);
          return;
        }
        this.renderUpdate(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
		this.itemProduct.classList.remove('is-remove');
    	this.shipping.classList.remove('is-loading');
      });
  }      
}

customElements.define('cart-dropdown-bubble', CartDropdown);
